  import {css, html, LitElement} from 'lit/index';
import {customElement, property} from 'lit/decorators';
import {repeat} from 'lit/directives/repeat.js';
import {normalizeStyles} from '@webs/components-library/theming';
  import {ifDefined} from 'lit-html/directives/if-defined.js';

@customElement('webs-button')
export class Button extends LitElement {

  static styles = [
    normalizeStyles,
    css`
    :host {
      --button-background-color: var(--color-base);
      --button-border-radius: 2.1rem;
      --button-color: var(--color-white);
      --button-font-family: var(--font-family-alternative);
      --button-font-weight: var(--font-weight-strong);
      --button-padding: .65rem 1.5rem;
    }

    .selector-wrapper {
      position: relative;
    }

    .selector-wrapper ul {
      background: var(--color-white);
      box-shadow: 8px 0px 50px rgba(24, 26, 35, 0.08);
      border-radius: 0px 0px 4px 4px;
      bottom: calc(100% + .3rem);
      left: 0;
      list-style: none;
      margin-bottom: .6rem;
      min-width: 100%;
      max-width: 280px;
      position: absolute;
      padding: 1rem 0;
      z-index: 1;
    }
    .selector-wrapper ul.active {
      display: block;
    }
    .selector-wrapper ul li {
      cursor: pointer;
      font-size: .7rem;
      font-weight: var(--font-weight-strong);
      padding: .65rem 2rem;
      transition: background .1s linear;
    }

    .selector-wrapper ul li:hover {
      color: var(--color-primary);
    }
    .button {
      align-items: center;
      background: var(--button-background-color);
      border-radius: var(--button-border-radius);
      color: var(--button-color);
      cursor: pointer;
      display: inline-flex;
      font: var(--button-font-weight) .8rem/1.3 var(--button-font-family);
      justify-content: center;
      outline: none;
      overflow: hidden;
      padding: var(--button-padding);
      position: relative;
      text-decoration: none;
      transition: background .1s linear, border .1s linear, color .1s linear;
      z-index: 1;

    }

    .art-arrow {
      display: none;
      margin-left: .5rem;
    }

    .button:not(.button--selector):not(.button--main-cta):hover {
      text-decoration: none;
      padding: .65rem 1rem;
    }

    .button:hover .art-arrow {
      display: block;
      background-position: center;
    }

    .button--main-cta:hover {
      background-position: center; background-size: cover; background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' preserveAspectRatio='none' viewBox='0 0 120 80'%3e%3cg mask='url(&quot;%23SvgjsMask1172&quot;)' fill='none'%3e%3cpath d='M194.42 84.19 a23.47 23.47 0 1 0 46.94 0 a23.47 23.47 0 1 0 -46.94 0z' fill='rgba(255, 0, 255, 0.7)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M91.728,129.684C100.801,129.513,110.336,126.557,114.544,118.517C118.545,110.874,114.382,102.226,109.985,94.804C105.705,87.579,100.125,80.022,91.728,80.001C83.307,79.979,77.736,87.547,73.308,94.71C68.536,102.43,63.139,111.379,67.368,119.409C71.77,127.767,82.284,129.863,91.728,129.684' fill='rgba(255, 0, 255, 0.7)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M-10.25 94.04 a27.17 27.17 0 1 0 54.34 0 a27.17 27.17 0 1 0 -54.34 0z' fill='rgba(255, 0, 255, 0.7)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M61.566,85.823C70.531,85.505,80.021,83.429,84.536,75.677C89.074,67.885,86.444,58.461,82.108,50.555C77.553,42.25,71.037,33.661,61.566,33.794C52.23,33.925,46.778,43.097,42,51.119C37.052,59.427,30.835,68.992,35.584,77.416C40.375,85.914,51.816,86.169,61.566,85.823' fill='rgba(255, 0, 255, 0.7)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M37.258,101.835C42.845,101.865,48.864,100.293,51.494,95.364C54.024,90.623,51.321,85.231,48.586,80.605C45.919,76.095,42.491,71.555,37.258,71.289C31.645,71.004,26.578,74.49,23.744,79.343C20.884,84.24,20.367,90.349,23.288,95.21C26.133,99.945,31.734,101.805,37.258,101.835' fill='rgba(255, 0, 255, 0.7)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M221.03 95.35 a29.18 29.18 0 1 0 58.36 0 a29.18 29.18 0 1 0 -58.36 0z' fill='rgba(255, 0, 255, 0.7)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M180.719,41.302C185.386,41.328,188.93,37.628,191.259,33.584C193.583,29.549,194.632,24.827,192.631,20.622C190.322,15.767,186.094,11.318,180.719,11.427C175.462,11.534,171.851,16.33,169.618,21.09C167.736,25.101,168.245,29.585,170.378,33.469C172.609,37.532,176.084,41.277,180.719,41.302' fill='rgba(255, 0, 255, 0.7)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M229.491,113.657C239.915,113.782,252.149,114.64,257.576,105.739C263.121,96.645,257.772,85.49,252.197,76.415C246.96,67.89,239.496,59.929,229.491,60.025C219.608,60.12,212.6,68.362,207.528,76.844C202.272,85.634,197.304,96.282,202.551,105.078C207.726,113.753,219.391,113.536,229.491,113.657' fill='rgba(255, 0, 255, 0.7)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M226.03 97.57 a32.31 32.31 0 1 0 64.62 0 a32.31 32.31 0 1 0 -64.62 0z' fill='rgba(255, 0, 255, 0.7)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M21.61 26.97 a20.89 20.89 0 1 0 41.78 0 a20.89 20.89 0 1 0 -41.78 0z' fill='rgba(255, 0, 255, 0.7)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M139.905,89.049C148.484,89.157,156.454,84.343,160.574,76.817C164.543,69.566,163.684,60.691,159.247,53.717C155.124,47.236,147.586,44.314,139.905,44.332C132.26,44.35,124.743,47.307,120.72,53.808C116.488,60.647,116.272,69.246,120.117,76.309C124.137,83.694,131.498,88.943,139.905,89.049' fill='rgba(255, 0, 255, 0.7)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M98.98 66.67 a24.47 24.47 0 1 0 48.94 0 a24.47 24.47 0 1 0 -48.94 0z' fill='rgba(255, 0, 255, 0.7)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M245.69 52.12 a30.24 30.24 0 1 0 60.48 0 a30.24 30.24 0 1 0 -60.48 0z' fill='rgba(255, 0, 255, 0.7)' class='triangle-float3'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1172'%3e%3crect width='300' height='100' fill='%23ffffff'%3e%3c/rect%3e%3c/mask%3e%3cstyle%3e %40keyframes float1 %7b 0%25%7btransform: translate(0, 0)%7d 50%25%7btransform: translate(-10px, 0)%7d 100%25%7btransform: translate(0, 0)%7d %7d .triangle-float1 %7b animation: float1 3s infinite; filter: blur(.5rem) %7d %40keyframes float2 %7b 0%25%7btransform: translate(0, 0)%7d 50%25%7btransform: translate(-5px, -5px)%7d 100%25%7btransform: translate(0, 0)%7d %7d .triangle-float2 %7b animation: float2 2s infinite; filter: blur(.5rem) %7d %40keyframes float3 %7b 0%25%7btransform: translate(0, 0)%7d 50%25%7btransform: translate(0, -10px)%7d 100%25%7btransform: translate(0, 0)%7d %7d .triangle-float3 %7b animation: float3 4s infinite; filter: blur(1rem) %7d %3c/style%3e%3c/defs%3e%3c/svg%3e");
    }

    .button--selector svg {
      margin-left: .3rem;
    }

    .button--selector.active {
      background: var(--color-light-grey);
      color: var(--color-base);
    }

    .button--selector.active svg {
      transform: scaleY(-1);
    }

    .button--selector.active svg path { fill: var(--color-base); }

    .button--main-cta {
      background: var(--color-primary);
    }

    .button--white {
      background: var(--color-white);
      color: var(--color-base);
    }

    .button--white svg circle {
      fill: var(--color-base);
    }
  `
  ];

  private show = false;

  @property()
  href: string;
  @property({attribute: 'new-tab', type: Boolean})
  openInNewTab = false;
  @property()
  rel: string;
  @property()
  text: string;
  @property()
  type: string;
  @property({attribute: 'select-options', type: Array})
  selectOptions: string[];

  protected render(): unknown {
    return html`
      ${this.type == 'selector' ? html`
          <div class="selector-wrapper">
            <a part="button" class="module-action button button--selector" @click=${this.toggleList}>
              ${this.text}

              <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M11.9636 6.11173C12.0962 6.24429 12.0962 6.4592 11.9636 6.59175L11.2954 7.25999C11.1628 7.39254 10.9479 7.39254 10.8153 7.25999L6.59188 3.03652C6.45933 2.90397 6.24441 2.90397 6.11186 3.03652L1.88839 7.25999C1.75584 7.39254 1.54093 7.39254 1.40837 7.25999L0.740137 6.59175C0.607583 6.4592 0.607583 6.24429 0.740137 6.11173L6.11186 0.74001C6.24441 0.607456 6.45933 0.607457 6.59188 0.740011L11.9636 6.11173Z"
                      fill="white"/>
              </svg>
            </a>

            ${this.selectOptions ? html`
              <ul ?hidden=${!this.show}>
                ${repeat(this.selectOptions, (item, index) => html`
                  <li @click="${this.selectItem}">${item}</li>`)}
              </ul>
            ` : ''}

          </div>`
        : html`
          <a part="button" class="module-action button ${this.type ? 'button--' + this.type : ''}" href="${ifDefined(this.href)}"
             target="${this.openInNewTab ? '_blank' : ''}"
             rel="${this.rel ? this.rel : ''}">
            ${this.text}

            ${this.type !== 'main-cta' ? html`
              <svg class="art-arrow" width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="7.5" cy="6" r="2" fill="white"/>
                <circle cx="2" cy="2.75" r="2" fill="white"/>
                <circle cx="2" cy="9.25" r="2" fill="white"/>
              </svg>
            ` : ''}

          </a>`
      }
    `;
  }

  private selectItem(event: MouseEvent): void {
    const itemId:string = (event.target as HTMLElement).textContent;
    const currentItem: HTMLElement = document.querySelector(`#${itemId}`);

    //TODO: make this general for other situations
    const forms: NodeListOf<HTMLElement> = currentItem.parentElement.querySelectorAll('.newsletter-form');

    forms.forEach((item, index)=>{
      if(item.id !== itemId){
        item.classList.remove('active');
      }
    })

    currentItem.classList.add('active');

    this.toggleList(event);
  }

  private toggleList(event: MouseEvent): void{
    this.show = !this.show;
    const currentElement:HTMLElement = (event.target as HTMLElement).classList.contains('button') ? event.target as HTMLElement : (event.target as HTMLElement).parentElement.parentElement.querySelector('.button');

    currentElement.classList.toggle('active');
    this.requestUpdate();
  }
}

